// extracted by mini-css-extract-plugin
module.exports = {"NavItem":"NavItem_NavItem__3yYWK","active":"NavItem_active__37SY1"};